<template>
  <!-- 商品信息（新增/编辑） -->
  <div class="product-detail">
    <list-page>
      <list-table class="list-table" background-color="#FFF">
        <!-- 基本信息 -->
        <form-tag label="基本信息"/>
        <form-items :columns="3" :data="dataDetail">
          <form-item label="商品名称" :required="true" name="productName" error-message="请输入商品名称">
            <el-input v-model="dataDetail.productName" placeholder="请输入商品名称"/>
          </form-item>
          <form-item label="商品简称">
            <el-input v-model="dataDetail.shortName" placeholder="请输入商品简称"/>
          </form-item>
          <form-item label="拼音码">
            <el-input v-model="dataDetail.pinyinCode" placeholder="请输入拼音码"/>
          </form-item>
          <form-item label="商品类型" :required="true" name="productType" error-message="请选择商品类型">
            <el-select :disabled="dataDetail.id" v-model="dataDetail.productType" placeholder="请选择商品类型">
              <el-option v-for="t in productTypeList" :key="t.code" :value="t.code" :label="t.name" :disabled="t.code !== 4"/>
            </el-select>
          </form-item>
          <form-item label="品牌">
            <el-select v-model="dataDetail.brandId" placeholder="请选择品牌" clearable>
              <el-option v-for="b in bradeList" :key="b.dictCode" :value="b.dictCode" :label="b.dictName"/>
            </el-select>
          </form-item>
          <form-item label="产地">
            <el-input v-model="dataDetail.origin" placeholder="请输入产地"/>
          </form-item>
          <form-item label="商品分类" :required="true" name="categoryId" error-message="请选择商品分类">
            <el-tree-select v-model="dataDetail.categoryId" :data="categoryTree" default-expand-all check-strictly
                            :render-after-expand="true" placeholder="请选择商品分类"
                            :props="{children: 'children', label: 'dictName'}" node-key="dictCode"/>
          </form-item>
          <form-item label="规格">
            <el-input v-model="dataDetail.spec" placeholder="请输入规格，如 550ml*24"/>
          </form-item>
          <form-item label="型号">
            <el-input v-model="dataDetail.model" placeholder="请输入型号"/>
          </form-item>

          <form-item label="状态">
            <el-select v-model="dataDetail.status" placeholder="请选择状态">
              <el-option label="上架" :value="1"/>
              <el-option label="下架" :value="0"/>
            </el-select>
          </form-item>
        </form-items>
        <!-- 计量单位 -->
        <form-tag label="计量单位"/>
        <div class="product-units" style="width: 30%">
          <div class="product-unit">
            <div class="unit-name">基本单位<span class="required">*</span></div>
            <form-items label-width="2.4rem" :columns="1">
              <form-item label="单位名称">
                <el-select v-model="dataDetail.unitIdBase" placeholder="请选择单位" @change="changeBaseUnit">
                  <el-option v-for="u in unitList" :key="u.dictCode" :value="u.dictCode" :label="u.dictName"/>
                </el-select>
              </form-item>
              <form-item label="换算率">
                <el-input :value="1" disabled placeholder="" class="no-colon">
                  <template #prepend>{{findUnitName(dataDetail.unitIdBase) || '基本单位'}}</template>
                  <template #prefix>=</template>
                  <template #append>{{findUnitName(dataDetail.unitIdBase) || '基本单位'}}</template>
                </el-input>
              </form-item>
              <form-item label="商品编码" name="productCode" error-message="请输入商品编码">
                <el-input v-model="dataDetail.productCodeBase" placeholder="请输入商品编码" :disabled="dataDetail.skuType === 2"/>
              </form-item>
              <form-item label="采购价格" >
                <el-input v-model="dataDetail.buyPriceBase" placeholder="请输入采购价格" :disabled="dataDetail.skuType === 2"/>
              </form-item>
              <form-item label="销售价格">
                <el-input v-model="dataDetail.salePriceBase" placeholder="请输入销售价格" :disabled="dataDetail.skuType === 2"/>
              </form-item>
            </form-items>
          </div>
        </div>
        <!-- 组合信息 -->
        <form-tag label="组合信息"/>
        <product-select-table ref="comboTable" v-model="dataDetail.comboList" :multi="true" @table-select-multi="addList2Combo" height="auto">
          <yq-table-column label="商品单位" prop="unitName">
            <template v-slot="{row}">
              <el-select v-model="row.productUnitId" placeholder="请选择商品单位">
                <template v-for="unit in unitList">
                  <el-option v-if="unit.dictCode === row.unitIdBase || unit.dictCode === row.unitIdMiddle || unit.dictCode === row.unitIdLarge" :value="unit.dictCode" :label="unit.dictName" />
                </template>
              </el-select>
            </template>
          </yq-table-column>
          <yq-table-column label="商品数量" prop="comboInt">
            <template v-slot="{row}">
              <el-input v-model="row.productComboInt" placeholder="请输入商品数量"/>
            </template>
          </yq-table-column>
          <yq-table-column label="操作" prop="options" align="center" width="90rem">
            <template v-slot="{row, $index}">
              <table-button el-type="danger" @click="deleteComboList($index)">删除</table-button>
            </template>
          </yq-table-column>
        </product-select-table>
        <div class="add-item-btn" @click="addCombo">
          <yq-icon name="element-ui_plus"/>添加组合信息
        </div>
        <!-- 序列号（仅新增时可设置，编辑锁定） -->
        <form-tag label="序列号"/>
        <form-items :columns="1" :data="dataDetail">
          <form-item label="序列号功能" :show-block="true">
            <el-switch :disabled="!!dataDetail.id" v-model="dataDetail.serialEnabled" :active-value="1" :inactive-value="0" style="--el-switch-off-color: #999"/>
            <span class="description-text">开启序列号后，出入库可添加对应的序列号，序列号可对商品进行一对一的追踪，保存后不可修改</span>
          </form-item>
          <form-item label="强制序列号" :show-block="true">
            <el-switch :disabled="!dataDetail.serialEnabled || !!dataDetail.id" v-model="dataDetail.serialRequired" :active-value="1" :inactive-value="0" style="--el-switch-off-color: #999"/>
            <span class="description-text">开启强制序列号后，出入库必须添加序列号，否则无法进行操作</span>
          </form-item>
        </form-items>
        <!-- 辅助信息 -->
        <form-tag label="辅助信息"/>
        <yq-table :data="auxiliaryList" height="auto" row-key="id" ref="auxiliaryList">
          <yq-table-column label="字段名称" prop="key" min-width="180rem">
            <template v-slot="{row}">
              <el-input placeholder="请输入字段名称，如 产地/板型/原料" v-model="row.key" size="small"/>
            </template>
          </yq-table-column>
          <yq-table-column label="字段值" prop="value" min-width="240rem">
            <template v-slot="{row}">
              <el-input placeholder="请输入字段值" v-model="row.value" size="small"/>
            </template>
          </yq-table-column>
          <yq-table-column label="操作" prop="option" align="center" width="90rem">
            <template v-slot="{row, $index}">
              <table-button el-type="danger" @click="deleteAuxiliary($index)">删除</table-button>
            </template>
          </yq-table-column>
        </yq-table>
        <div class="add-item-btn" @click="addAuxiliary">
          <yq-icon name="element-ui_plus"/>添加辅助信息
        </div>

        <!-- 图文信息 -->
        <form-tag label="图文信息"/>
        <form-items :columns="2" class="product-image-info" :data="dataDetail">
          <form-item label="商品图片" :show-block="true">
            <image-upload v-model="dataDetail.image" :limit="1" width="80px" height="80px" upload-tips="建议尺寸:100px*100px"/>
          </form-item>
          <form-item label="轮播图片" :show-block="true">
            <image-upload v-model="dataDetail.images" :limit="5" width="80px" height="80px" upload-tips="图片建议尺寸:400px*300px"/>
          </form-item>
          <form-item label="详情描述" :show-block="true">
            <rich-text v-model="dataDetail.description"/>
          </form-item>
        </form-items>
      </list-table>

      <!-- 属性值编辑弹框 -->


      <form-page :show-page="false">
        <div class="update-price-scheme">
          <el-switch v-model="dataDetail.updatePriceScheme" :active-value="1" :inactive-value="0"/><span>同步更新默认价格方案</span>
        </div>
        <page-button el-type="primary" @click="saveProduct">保存</page-button>
        <page-button el-type="success" @click="saveProductAndRenew">保存并新建</page-button>
        <page-button @click="router.go(-1)">取消</page-button>
      </form-page>
    </list-page>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import FormTag from "@/components/h5/layout/FormTag.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import ImageUpload from "@/components/h5/image/ImageUpload.vue";
import RichText from "@/components/h5/richText/RichText.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import helpJs from "./ProductUtil";
import commonApi from "@/api/commonApi.js";
import productApi from "@/api/normal/product/productApi.js";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqTable from "@/components/h5/table/YqTable.vue";
import YqIcon from "@/components/YqIcon.vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import ProductSelectTable from "@/components/h5/product/ProductSelectTable.vue";
import util from "@/util/util";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "ProductDetail",
  components: {
    YqIcon, ProductSelectTable, YqTable, TableButton, YqTableColumn, DialogTable, ImageUpload, RichText, PageButton, ListPage, ListTable, FormPage, FormTag, FormItems, FormItem
  },
  data() {
    return {
      dataDetail: this.getNewData(),
      // 商品类型 1 库存 2虚拟商品 3计次商品 4组合商品
      productTypeList: [],
      categoryTree: [], // 商品分类
      bradeList: [], // 品牌
      unitList: [], // 计量单位
      produceList: [], // 生产企业
      // 辅助信息（k-v，保存时转成 auxiliaryInfo JSON）
      auxiliaryList: [],
      // 属性值编辑弹框
      showAttrValueDialog: false,
      currentAttrRow: null,
      currentAttrName: '',
      attrValueInput: '',
    };
  },
  computed: {

  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    if (!Util.loadPageData(this)) { // 加载缓存数据失败，初始化页面
      commonApi.queryDictionaryTree("PRODUCT_CATEGORY").then(list => this.categoryTree = list);
      commonApi.queryUniqueDictionaryList("PRODUCT_BRADE").then(list => this.bradeList = list);
      commonApi.queryUniqueDictionaryList("PRODUCT_UNIT").then(list => this.unitList = list);
      commonApi.queryUniqueDictionaryList("PRODUCT_MERCHANT").then(list => this.produceList = list);
      // 获取系统配置 商品类型配置
      util.getSystemSettingOptions("PRODUCT_STOCK_TYPE").then(list => this.productTypeList = list);
    }
    if (this.route.query.id) {
      // 编辑回显
      this.findById(this.route.query.id);
    } else {
      this.reNew();
    }
  },
  methods: {
    // 编辑回显
    findById(id) {
      productApi.findById(id).then(res => {
        this.dataDetail = helpJs.formatDetail(res);
        this.auxiliaryList = this.dataDetail.auxiliaryList || [];
        // 数据到位后再渲染富文本编辑器（避免初始化时机早于异步回显导致内容为空）
      });
    },
    // 基本单位切换
    changeBaseUnit() {
      if (this.dataDetail.skuList && this.dataDetail.skuList.length > 0) {
        this.dataDetail.skuList.forEach(c => {
          c.skuUnitId = this.dataDetail.unitIdBase;
        });
      }
    },
    findUnitName(id) {
      if (!id) return "";
      let u = this.unitList.find(it => it.dictCode === id);
      return u ? u.dictName : "";
    },
    // 添加辅助信息
    addAuxiliary() {
      this.auxiliaryList.push({
        id: 'aux_' + Date.now() + Math.floor(Math.random() * 1000),
        key: '',
        value: '',
      });
      this.$refs.auxiliaryList.showDataColumns();
    },
    // 向组合中添加一个商品
    addCombo() {
      this.$refs.comboTable.toSelectMore();
    },
    // 删除辅助信息
    deleteAuxiliary(index) {
      this.auxiliaryList.splice(index, 1);
      this.$refs.auxiliaryList.showDataColumns();
    },
    // 从组合中删除商品
    deleteComboList(index) {
      this.dataDetail.comboList.splice(index, 1);
      this.$refs.comboTable.refresh();
    },
    // 保存前把 auxiliaryList 序列化为 auxiliaryInfo
    buildAuxiliaryInfo() {
      let valid = this.auxiliaryList.filter(a => a.key && a.value);
      return JSON.stringify(valid);
    },
    // 保存
    saveProduct() {
      // 辅助信息序列化
      this.dataDetail.auxiliaryInfo = this.buildAuxiliaryInfo();
      helpJs.checkData(this.dataDetail);
      productApi.save(this.dataDetail).then(data => {
        this.dataDetail = helpJs.formatDetail(data);
        this.auxiliaryList = this.dataDetail.auxiliaryList || [];
        this.router.push('/product/info');
      })
    },
    reNew() {
      this.dataDetail = this.getNewData();
      this.auxiliaryList = [];
    },
    getNewData() {
      return {
        productName: "", shortName: "", pinyinCode: "", productCode: "",
        productType: 4, categoryId: "", brandId: "",
        spec: "", model: "", origin: "",
        status: 1, manufacturer: "", licenseNo: "",
        warrantyPeriod: "", warrantyUnit: 2,
        unitIdBase: "", unitIdMiddle: "", unitIdLarge: "",
        middleRate: "", largeRate: "",
        serialEnabled: 0, serialRequired: 0,
        skuType: 1, level: 1, skuList: [],
        image: "", images: "", description: "",
        attributeList: [], auxiliaryInfo: "",
        comboList: [],
        updatePriceScheme: 0, // 是否强制同步更新默认价格方案
      };
    },
    // 保存并新建
    saveProductAndRenew() {
      this.dataDetail.auxiliaryInfo = this.buildAuxiliaryInfo();
      helpJs.checkData(this.dataDetail);
      productApi.save(this.dataDetail).then(() => {
        this.reNew();
      })
    },
    // 向组合中添加多个商品
    addList2Combo(list) {
      for (let i = 0; i < list.length; i++) {
        // 找到组合信息
        for (let j = 0; j < this.dataDetail.comboList.length; j++) {
          if (this.dataDetail.comboList[j].skuId === list[i].id) {
            this.dataDetail.comboList[j].productComboId = list[i].id;
            this.dataDetail.comboList[j].productUnitId = list[i].unitIdBase; // 组合商品选中的单位
            this.dataDetail.comboList[j].unitIdBase = list[i].unitIdBase; // 小单位
            this.dataDetail.comboList[j].unitIdMiddle = list[i].unitIdMiddle; // 中单位
            this.dataDetail.comboList[j].unitIdLarge = list[i].unitIdLarge; // 大单位
            this.dataDetail.comboList[j].productComboInt = 1;
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.product-detail {
  height: 100%;

  .list-table {
    padding: 10px;
  }

  .required {
    color: var(--el-color-danger);
    margin-left: 5px;
  }

  .quality-period-wrap {
    display: flex;
    width: 100%;

    .quality-period {
      width: calc(100% - 80px);
    }

    .quality-period-unit {
      width: 80px;
      margin-left: 8px;
    }
  }

  .product-units {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    padding: 0 16px 10px;

    .product-unit {
      flex: 1;
      border: 1px solid var(--el-color-info-light-7);
      padding: 10px;
      box-sizing: border-box;

      .unit-name {
        text-align: center;
        font-weight: 600;
        padding-bottom: 10px;
        font-size: 15px;
      }
    }
  }

  .description-text {
    font-size: 12px;
    color: #999;
    margin-left: 10px;
  }

  .sku-tip {
    font-size: 12px;
    color: #999;
    margin-top: 8px;
  }

  .attribute-wrap {
    width: 100%;
  }

  .attr-value-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
  }

  .attr-value-tag {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: var(--el-color-primary-light-9);
    color: var(--el-color-primary);
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;

    &:hover {
      background: var(--el-color-primary-light-7);
    }

    .yq-icon {
      font-size: 12px;
    }
  }

  .attr-value-empty {
    color: var(--el-color-primary);
    font-size: 12px;
    cursor: pointer;
    border: 1px dashed var(--el-color-primary-light-5);
    padding: 2px 8px;
    border-radius: 4px;
  }

  .attr-value-add {
    color: var(--el-color-primary);
    cursor: pointer;
    font-size: 14px;
  }

  .attr-value-dialog {
    .attr-value-dialog-list {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-top: 12px;
    }
  }

  .add-item-btn {
    border: 1.5px dashed var(--yq-border-color);
    border-radius: 6px;
    padding: 8px;
    text-align: center;
    color: var(--yq-font-color-tips);
    font-size: 13px;
    cursor: pointer;
    margin-top: 8px;

    &:hover {
      color: var(--el-color-primary);
      border-color: var(--el-color-primary);
    }
  }

  .product-image-info {
    :deep(.el-descriptions__label) {
      vertical-align: top;
    }
  }
}

:deep(.el-input) {
  &.no-colon {
    .el-input__prefix-inner::after {
      content: "";
    }
  }
}

.update-price-scheme {
  font-size: var(--yq-font-size-small);
  color: var(--yq-font-color-tips);
  margin-right: 10px;
  display: inline-block;
}
</style>
